import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ErrorHandlerService } from '../../../../services/error-handler.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ServiceabonnementDialogData } from '../../../aftale/models';
import { ServiceAbonnementDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/service-abonnement-dto';
import { ServiceAbonnementService } from 'src/app/api/services/service-abonnement.service';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { LoaderService } from 'src/app/services/loader.service';
import { finalize, Subject, takeUntil } from 'rxjs';
import { ServiceAftaleService } from 'src/app/api/services';
import { SignalrService } from 'src/app/services/signalr.service';
import { UpdateServiceAbonnementRequestDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/update-service-abonnement-request-dto';
import { UpdateServiceabonnementResponseDto } from 'src/app/api/models/OK/Egis/Service/Models/Response/update-serviceabonnement-response-dto';
import { NotificationService } from 'src/app/notifications/services/notification.service';
import { NotificationType } from 'src/app/notifications/models/notification-models';
import { abonnementValidator } from 'src/app/validators/abonnement.validator';

@Component({
    selector: 'app-serviceabonnement-edit',
    templateUrl: './serviceabonnement-edit.component.html',
    styleUrls: ['./serviceabonnement-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ServiceabonnementEditComponent implements OnInit {
  form: UntypedFormGroup;
  serviceAbonnement: ServiceAbonnementDto;
  serviceaftaleCount: number;

  get opkraevningsinterval() {
    return this.form.get('opkraevningsinterval');
  }

  isLoading: boolean = false;

  isConnected: boolean;

  unsubscribe$ = new Subject<void>();

  constructor(
    private loader: LoaderService,
    private formBuilder: UntypedFormBuilder,
    private service: ServiceAbonnementService,
    private serviceaftaleService: ServiceAftaleService,
    private errorHandler: ErrorHandlerService,
    private signalR: SignalrService,
    private notification: NotificationService,
    public dialogRef: MatDialogRef<ServiceabonnementEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ServiceabonnementDialogData
  ) {
    this.serviceAbonnement = data.serviceAbonnement;
    let vareNrValidators = this.serviceAbonnement.isTilkaldsabonnement
      ? [Validators.required, Validators.min(0)]
      : [Validators.required, Validators.min(1)];
    this.form = this.formBuilder.group(
      {
        description: [data.serviceAbonnement.description, [Validators.required, Validators.minLength(3)]],
        fakturaDescription: new UntypedFormControl(
          { value: data.serviceAbonnement.fakturaDescription, disabled: data.serviceAbonnement.isTilkaldsabonnement },
          [Validators.nullValidator]
        ),

        okKundeVarenr: new UntypedFormControl(
          { value: data.serviceAbonnement.okKundeVarenr, disabled: data.serviceAbonnement.isTilkaldsabonnement },
          vareNrValidators
        ),

        opkraevningsinterval: new UntypedFormControl(
          { value: data.serviceAbonnement.opkraevningInterval, disabled: data.serviceAbonnement.isTilkaldsabonnement },
          [Validators.required]
        ),
        eftersynInterval: new UntypedFormControl(
          { value: data.serviceAbonnement.eftersynInterval, disabled: data.serviceAbonnement.isTilkaldsabonnement },
          [Validators.required]
        ),
      },
      {
        validators: abonnementValidator,
      }
    );
  }

  ngOnInit(): void {
    const request: UpdateServiceAbonnementRequestDto = {
      id: this.serviceAbonnement.id,
      description: this.form.value.description,
      okKundeVarenr: !this.serviceAbonnement.isTilkaldsabonnement ? Number(this.form.value.okKundeVarenr) : 0,
      fakturaDescription: this.form.value.fakturaDescription,
      opkraevningsinterval: this.form.value.opkraevningsinterval,
    };
    this.serviceaftaleService
      .getAftalerAffectedByAbonnementChange({
        body: request,
        caller: EGIS_SERVICE_CALLER,
      })
      .pipe(finalize(() => {}))
      .subscribe(
        (result) => {
          this.serviceaftaleCount = result;
        },
        (error) => {
          this.errorHandler.HandleError(error);
        }
      );

    this.signalR.isConnected$.subscribe(
      (isConnected: boolean) => {
        console.log('isConnected', isConnected);
        this.isConnected = isConnected;
      },
      (e) => {
        console.log(e);
      }
    );
  }

  update() {
    this.isLoading = true;
    let updated: UpdateServiceAbonnementRequestDto = {
      id: this.serviceAbonnement.id,
      description: this.form.value.description,
      okKundeVarenr: Number(this.form.value.okKundeVarenr),
      fakturaDescription: this.form.value.fakturaDescription,
      opkraevningsinterval: this.form.value.opkraevningsinterval,
    };

    this.signalR.updateServiceabonnementUpdated$.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (result: UpdateServiceabonnementResponseDto) => {
        console.log('updated in ' + result.elapsedSeconds + 'seconds');
        this.isLoading = false;
        this.notification.success('Serviceabonnementet er opdateret.');
        this.dialogRef.close(result.serviceAbonnement);
      },
      (e) => {}
    );

    this.signalR.updateServiceabonnementFailed$.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (result: string) => {
        this.isLoading = false;
        this.notification.error(result);
      },
      (e) => {}
    );

    this.service
      .updateServiceabonnementdescription({
        caller: EGIS_SERVICE_CALLER,
        body: updated,
      })
      .pipe(finalize(() => {}))
      .subscribe(
        () => {},
        (e) => {
          this.errorHandler.HandleError(e);
        }
      );
  }

  cancel() {
    this.dialogRef.close();
  }
}
